import React, { useEffect, useState } from 'react';
import { ArrowRight } from "lucide-react";
import { Link } from 'react-router-dom';
import LazyLoad from 'react-lazyload';
import AOS from 'aos';
import 'aos/dist/aos.css';
import BASE_URL from './apibaseurl/ApiBaseUrl';

export default function Blog() {


  const [blogs, setBlogs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      offset: 100,
    });
  }, []);

  useEffect(() => {
    setIsLoading(true);
    fetch(`${BASE_URL}/blogs`)
      .then((res) => res.json())
      .then((data) => {
        if (data.status === 1) {
          setBlogs(data.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching blog data:", err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);


  return (
    <>
      {/* Section 1: Hero */}
      <section className="flex flex-col" data-aos="fade-up">
        <div className="flex-grow">
          <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between px-6 py-20 gap-10">
            {/* Text Section */}
            <div className="max-w-xl space-y-5" data-aos="fade-right" data-aos-delay="100">
              <h2 className="text-5xl font-bold text-[#234042] Bebas-neue">BLOG</h2>
              <div className="flex items-center space-x-2 text-lg Bebas-neue">
                <span className="text-[#234042]">HOME</span>
                <span className="h-4 w-[1px] bg-gray-400"></span>
                <span className="text-[#F47321] tracking-light">BLOG</span>
              </div>
              <p className="text-[#234042] text-base leading-relaxed helvetica-neue">
                Explore insights, tips, and industry trends on how to get the most out of LiveQR. Whether you're a beginner or a pro, our blog is packed with valuable content to help you level up your QR code strategy.
              </p>
            </div>
            {/* Image */}
            <div className="relative" data-aos="zoom-in" data-aos-delay="200">
              <LazyLoad height={400} offset={50} once>
                <img
                  src="/images/blog.png"
                  alt="LiveQR process illustration"
                  className="w-full max-w-md"
                />
              </LazyLoad>
            </div>
          </div>
        </div>
      </section>

      {/* Section 2: Blog Cards */}
      <section className="max-w-7xl mx-auto px-6 pb-20" data-aos="fade-up" data-aos-delay="100">
        {isLoading ? (
          <div className="flex justify-center items-center min-h-[450px]">
            <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-[#F47321]"></div>
          </div>
        ) : (
          <>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {blogs.map((blog, index) => (
                <Link to={`/blog/${blog.slug}`} key={blog.id}>
                  <div
                    className="overflow-hidden flex flex-col border rounded shadow"
                    style={{ minHeight: "450px" }}
                    data-aos="zoom-in"
                    data-aos-delay={`${index * 100}`}
                  >
                    <div className="flex-shrink-0 overflow-hidden group">
                      <LazyLoad height={320} offset={50} once>
                        <img
                          src={blog.picture}
                          alt={blog.title}
                          className="w-full h-80 object-cover transition-transform duration-1000 group-hover:scale-110"
                        />
                      </LazyLoad>
                    </div>
                    <div className="bg-[#234042] text-white text-left px-6 py-6 flex flex-col flex-grow">
                      <h3 className="text-base font-medium text-[#FFFFFF] oswald">{blog.title}</h3>
                      <div className="text-sm font-medium flex items-center gap-2 text-white opacity-80 cursor-pointer oswald">
                        READ MORE
                        <span className="text-xl">
                          <ArrowRight className="w-4 h-4" />
                        </span>
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
            
            {/* <div className="mt-12 text-center px-4 mx-auto flex items-center justify-center lg:justify-center" data-aos="fade-up" data-aos-delay="200">
              <Link to="/blog">
                <button
                  type="button"
                  className="bg-[#F47321] hover:bg-opacity-90 text-white rounded-none flex items-center justify-center gap-2 transition transform scale-y-125 text-xs lg:text-[18px] lg:px-4 lg:py-3 px-2 py-2 btn-hover-effect"
                >
                  <span>LEARN MORE</span>
                  <span className="icon-arrow-right">
                    <ArrowRight className="w-4 h-4" />
                  </span>
                </button>
              </Link>
            </div> */}
          </>
        )}
      </section>
    </>
  );
}